import React from 'react';
import { Badge } from '@mantine/core';

const STATUS_CONFIG = {
  not_required: { color: 'gray',   label: 'No Consent Needed' },
  required:     { color: 'orange', label: 'Consent Not Sent' },
  pending:      { color: 'yellow', label: 'Consent Pending' },
  received:     { color: 'green',  label: 'Consent Received' }
};

const ConsentStatusBadge = ({ status }) => {
  // Falling back to not_required would label a minor with no consent as
  // "No Consent Needed" — the opposite of the truth. An unknown status is a
  // bug, so say so rather than reassure.
  const config = STATUS_CONFIG[status]
    || { color: 'red', label: status ? `Unknown (${status})` : 'Consent Unknown' };
  return (
    <Badge color={config.color} variant="light" size="xs">
      {config.label}
    </Badge>
  );
};

export default ConsentStatusBadge;
